import type { FirmStaffMember } from '~/stores/staff'

/**
 * The firm-staff roles as human labels. Shared by the Staff roster and the
 * client-detail Account Team card, which both name a member's role, so the map
 * lives here rather than being duplicated in each page. `owner` is the founder's
 * ownership row surfaced as a role (see `firmStaffPermissions`).
 */
export const ROLE_LABELS: Record<FirmStaffMember['role'], string> = {
  org_admin: 'Firm admin',
  org_finance_admin: 'Finance admin',
  accounting_firm_member: 'Accountant',
  owner: 'Owner',
}

/**
 * Falls back to the raw role rather than blank, so a role the contract grows
 * before the portal is redeployed still renders as itself.
 */
export function roleLabel(role: FirmStaffMember['role']): string {
  return ROLE_LABELS[role] || role
}
